// removed by extract-text-webpack-plugin
module.exports = {"footer":"ht7LZR8K267DyQ_g_LFLT","info":"_2SpFs484Orea_SL06rldzF","label":"brq8bVyiEvzvretDvAU-5","mainText":"_3cf3cys6uXdN38-xFcDPIN","subText":"RMxvkYtUGDk9d_N7Kg16v","btn":"_2eGhA3v8Gn2WXJEjsTeq0N","loading":"LcK-AbCKFmJVH2--CbLIt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/FooterBooking.scss
// module id = 1106
// module chunks = 0